module.exports = __webpack_public_path__ + "img/chart-default.2e61255a.svg";